import React from 'react';

const AsyncCorpusClient = React.lazy(() => import('./ClientCorpusContainer'));
export const CorpusClientPage = () => {
  return <AsyncCorpusClient />;
};
